// extracted by mini-css-extract-plugin
export var avatarContainer = "_cz-0";
export var gray = "_cz-f";
export var green = "_cz-c";
export var icon = "_cz-9";
export var image = "_cz-1";
export var lg = "_cz-6";
export var md = "_cz-5";
export var presenceDot = "_cz-b";
export var red = "_cz-d";
export var sm = "_cz-4";
export var status = "_cz-a";
export var xl = "_cz-7";
export var xs = "_cz-3";
export var xxl = "_cz-8";
export var xxs = "_cz-2";
export var yellow = "_cz-e";